<template>
  <el-dialog :title="receiveData.title" class="withdraw-dialog" :visible.sync="centerDialogVisible" @close="closeDialog" width="30%" center>
    <el-form label-position="right" label-width="90px" :model="receiveData" v-if="receiveData.title !== '提示'">
      <el-form-item label="媒体商ID：">
        <el-input v-model="receiveData.info.UserId" disabled></el-input>
      </el-form-item>
      <el-form-item label="提取金额：">
        <el-input v-model="receiveData.info.PretaxAmount" disabled></el-input>
      </el-form-item>
      <el-form-item label="备注：" v-if="receiveData.remark">
        <el-input type="textarea" v-model="remark"></el-input>
      </el-form-item>
    </el-form>
    <p v-else>确认批量通过？</p>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="confirmDialog">{{receiveData.type}}</el-button>
    </span>
  </el-dialog>

</template>
<script>
export default {
  data() {
    return {
      remark: ""
    };
  },
  props: {
    dialogPragram: Object,
    isShowdialog: Boolean
  },
  computed: {
    receiveData() {
      return this.dialogPragram;
    },
    centerDialogVisible() {
      return this.isShowdialog;
    }
  },
  methods: {
    closeDialog() {
      this.$emit("close");
      this.remark = "";
    },
    confirmDialog() {
      var confirmData = {
        businessId: this.dialogPragram.info.BusinessId,
        status: this.changeStatus(
          this.dialogPragram.info.Status,
          this.dialogPragram.type
        ),
        remark: this.remark
      };

      this.dialogPragram.callback(confirmData);
      this.remark = "";
    },
    changeStatus(status, type) {
      if (type === "通过") {
        switch (status) {
          case 1:
            return 2;
            break;
          case 2:
            return 3;
            break;
          case 3:
            return 4;
            break;
        }
      } else {
        switch (status) {
          case 1:
            return 5;
            break;
          case 2:
            return 6;
            break;
          case 3:
            return 7;
            break;
        }
      }
    }
  }
};
</script>
<style lang="scss">
// @import "../../../common/scss/color.scss";\
.withdraw-dialog {
  .el-dialog__header {
    background-color: #409eff;
    padding: 10px 20px 10px;
  }
  .el-dialog__title {
    color: #fff;
  }
  .el-dialog__headerbtn {
    transform: translateY(-50%);
    .el-dialog__close {
      color: #fff;
    }
  }

  .el-dialog__body {
    padding: 20px 25px 0px;
    p {
      font-size: 16px;
      font-weight: 500;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/import-preview/confirm-withdraw-dialog.vue